export default __webpack_public_path__ + "static/media/guardian.d2ebeba6.png";